window.DraggableElements = (function() {
  let activeElement = null;
  let startX, startY;
  let offsetX, offsetY;
  let hasMoved = false;
  let moveThreshold = 5;
  let startTime = 0;
  const CLICK_TIMEOUT = 250;

  function init(products) {
    console.log('Initializing draggable functionality');

    products.forEach(function(product) {
      product.addEventListener('mousedown', dragStart);
      product.addEventListener('touchstart', dragStart, { passive: false });
      
      const optionsPopup = product.querySelector('.product-options-popup');
      if (optionsPopup) {
        optionsPopup.addEventListener('mousedown', function(e) {
          e.stopPropagation();
        });
        
        optionsPopup.addEventListener('touchstart', function(e) {
          e.stopPropagation();
        }, { passive: false });
      }
    });

    document.addEventListener('mousemove', drag);
    document.addEventListener('touchmove', drag, { passive: false });
    document.addEventListener('mouseup', dragEnd);
    document.addEventListener('touchend', dragEnd);
  }

  function dragStart(e) {
    if (e.target.closest('.product-options-popup, .teleport-popup')) {
      console.log('Ignoring drag on product options popup');
      return;
    }

    const element = e.target.closest('.product-card, #glb-model-container');
    if (!element) return;
    
    e.preventDefault();

    hasMoved = false;
    startTime = Date.now();

    activeElement = element;
    
    activeElement.style.cursor = 'grabbing';
    activeElement.style.zIndex = '10';
    
    const rect = activeElement.getBoundingClientRect();
    
    if (e.type === 'touchstart') {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    } else {
      startX = e.clientX;
      startY = e.clientY;
    }
    
    offsetX = rect.left - startX;
    offsetY = rect.top - startY;
    
    activeElement.setAttribute('data-dragging', 'false');
  }

  function drag(e) {
    if (!activeElement) return;
    
    e.preventDefault();
    
    let currentX, currentY;
    if (e.type === 'touchmove') {
      currentX = e.touches[0].clientX;
      currentY = e.touches[0].clientY;
    } else {
      currentX = e.clientX;
      currentY = e.clientY;
    }
    
    const deltaX = Math.abs(currentX - startX);
    const deltaY = Math.abs(currentY - startY);
    
    if (!hasMoved && (deltaX > moveThreshold || deltaY > moveThreshold)) {
      hasMoved = true;
      activeElement.setAttribute('data-dragging', 'true');
    }
    
    activeElement.style.left = (currentX + offsetX) + 'px';
    activeElement.style.top = (currentY + offsetY) + 'px';
  }

  function dragEnd(e) {
    if (!activeElement) return;
    
    const dragDuration = Date.now() - startTime;
    
    activeElement.style.cursor = 'grab';
    activeElement.style.zIndex = '1';
    
    const wasClicked = !hasMoved && dragDuration < CLICK_TIMEOUT;
    
    if (wasClicked) {
      console.log('clicked');
      if (activeElement.classList.contains('product-card')) {
        const clickEvent = new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        });
        setTimeout(() => {
          activeElement.dispatchEvent(clickEvent);
        }, 10);
      } else if (activeElement.id === 'glb-model-container') {
        console.log('GLB clicked');
        const teleportPopup = activeElement.querySelector('.teleport-popup');
        if (teleportPopup) {
          teleportPopup.classList.add('active');
          document.querySelectorAll('.product-options-popup.active').forEach(popup => {
            popup.classList.remove('active');
          });
        }
      }
    }

    setTimeout(function() {
      if (activeElement) {
        activeElement.removeAttribute('data-dragging');
      }

      activeElement = null;
      hasMoved = false;
    }, 50);
  }
  
  return {
    init: init,
    dragStart: dragStart
  };
})();